import { createAsyncThunk } from "@reduxjs/toolkit";
import { type MovementsSummary } from "../../../domain/entities/batch";
import { type BatchesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const getMovementsSummary = createAsyncThunk<
  MovementsSummary,
  string,
  { dispatch: BatchesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.GET_MOVEMENTS_SUMMARY, async (businessDate, { extra }) => {
  return await extra.batchesRepo.getMovementsSummary(businessDate);
});
